/**
 * Storage Store.
 * User: herbert
 */



import Reflux from 'reflux';
import request from 'request';

import storageActions from '../actions/storage-actions.js';
import userActions from '../actions/user-actions.js';
import stepActions from '../../slxstep/actions/step-actions.js';

import steleStore from '../../stele/stores/stele-store.js';

//import * as stepConfig from '../../../config-steps.js';
//import * as config from '../../../config.js';

export default Reflux.createStore({
	init: function () {
		const target = location.href.slice(0, location.href.lastIndexOf('/')) + '/php/model.php';
		console.log('storage-store: target-url: ',target);
		this.listenToMany(storageActions);
		this.state = {
			/** data, ie. base64 string corresponding to token or null */
			data: null,
			/** token corresponding to data or null<br />
			 *  If using token data MUST BE compared  each time to the current value of steleStore.getKey()
			 */
			token: null
		};

		/**
		 * store data on server
		 * @Function
		 * @param[Object} options object containing the body, i.e. { body: ... }
		 */
		this._send = request.defaults({
			url: target,
			method: 'POST',
			callback: this._sendCallback
		});
		// will have to add qs object whenn calling this.load
		/**
		 * fetch data from server(they return a AsyncToken to make the calls identifyable)
		 * @Function
		 * @param[Object} options object containing the qs object with token, i.e. { qs: { token: <TOKEN from save/user> } }
		 */
		this._fetch = request.defaults({
			url: target,
			//method: 'GET', // default
			json: true,
			callback: this._fetchCallback
		});
	},
	_lastSend: {
		/** the last issued request as returned by require */
		request: null,
		/** the error callback of the last issued request as supplied be the caller */
		errorCallback: null
	},
	_lastFetch: {
		/** the last issued request as returned by require */
		request: null,
		/** the error callback of the last issued request as supplied be the caller */
		errorCallback: null
	},
	_sendCallback: function (error, /**http.IncomingMessage*/ response, /**JSON*/ body) {
		if (response && response.request !== this._lastSend.request)
			return;
		if (error || response.statusCode < 200 || response.statusCode >= 300) {
			this.state.data = null;
			if (this._lastSend.errorCallback) {
				this._lastSend.errorCallback(error, response, body);
			}
		} else {
			try {
				const tokenObject = JSON.parse(body);
				this.state.token = tokenObject.token;
				//console.log('sucessfully parsed send result', response, body);
			} catch (ex) {
				console.error('error parsing send result', body, ex);
				if (this._lastSend.errorCallback) {
					this._lastSend.errorCallback(ex, response, body);
				}
			}
		}
		this._lastSend.request = null;
		this._lastSend.errorCallback = null;
		this.output();
	},
	_fetchSuccess: function () {
		//console.log('_fetchSuccess');
		userActions.close();
		stepActions.switchStep('config', '');
	},
	_fetchCallback: function (error, /**http.IncomingMessage*/ response, /**JSON*/ body) {
		//console.log((response && response.request !== this._lastFetch.request), (error || response.statusCode < 200 || response.statusCode >= 300), error, (response ? response.statusCode : '--'), body);
		if (response && response.request !== this._lastFetch.request)
			return;
		if (error || response.statusCode < 200 || response.statusCode >= 300) {
			this.state.data = null;
			this.state.token = null;
			if (this._lastFetch.errorCallback)
				this._lastFetch.errorCallback(error, response, body);
		} else {
			this.state.data = body;
			steleStore.loadFromKey(this.state.data, this._fetchSuccess, this._lastFetch.errorCallback);
		}
		this._lastFetch.request = null;
		this._lastFetch.errorCallback = null;
		this.output();
	},
	output: function () {
		this.trigger(this.getInitialState());
	},
	getInitialState: function () {
		return this.state;
	},

	/** send data to storage
	 * @param{Function} errorCallback  called if error occurs
	 */
	send: function (errorCallback) {
		// state @param
		/** @type{String} data data sent to storage. this is not modify and has to comply with data accepted by the server, i.e. beeing coded in base64 */
		const data = steleStore.getKey();
		console.log('send', (this.state.data !== data || !this.state.token), data);
		if (this.state.data !== data || !this.state.token) {
			this.state.data = data;
			this.state.token = null;
			this._lastSend.errorCallback = errorCallback;
			this._lastSend.request = this._send({body: data});
		}
	},
	/** fetch data from storage
	 * @param{String} token server ID of data to fetch
	 * @param{Function} errorCallback  called if error occurs
	 */
	fetch: function (token, errorCallback) {
		console.log('fetch', (token && token !== this.state.token || !this.state.data), token);
		if (token && token !== this.state.token || !this.state.data) {
			this.state.token = token;
			this.state.data = null;
			this._lastFetch.errorCallback = errorCallback;
			this._lastFetch.request = this._fetch({qs: {token: token}});
		} else {
			console.log('won\'t load current configuration again');
			this._fetchSuccess(); // ist ja eh schon das richtige geladen
			this.output();
		}
	}
});
